import React, { useEffect, useState } from 'react';
import styles from './testStart.module.scss';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import { CommonButton } from '../../common/button';
import Webcam from '../../common/webcam/Webcam';
import NoSsr from '@common/noSsr';
import { RESOLUTION, WebcamStatus } from '@domain/constant/webcamTypes';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Button from '@components/common/button';

const cx = classNames.bind(styles);

export const TestStart = () => {
  const recorderService = useInterviewPracticeStore((state) => state.recorderService, shallow);
  const micScale = useInterviewPracticeStore((state) => state.micScale);
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const [enabled, setEnabled] = useState(false);

  const handleClickStart = () => {
    setEnabled(false);
    setTimeout(() => toNextStep(), 500);
  };

  useEffect(() => {
    setTimeout(() => setEnabled(true), 500);
  }, []);

  return (
    <CommonCard className={cx('card', { enabled })}>
      <div className={cx('header')}>
        <div className={cx('title')}>지원자님의 환경상태를 체크하세요</div>
        <div className={cx('guide')}>
          준비가 됐으면 ‘환경체크 시작’ 버튼을 누른 뒤, <br />
          “안녕하세요! 만나서 반갑습니다”를 말씀해주세요.
        </div>
      </div>
      <div className={cx('webcamContainer')}>
        <NoSsr>
          <Webcam
            className={cx('webcam')}
            stream={recorderService.recorder?.stream ?? null}
            initialized={recorderService.recorder !== null}
            micActive={micScale > 10}
            videoRecording={recorderService.status === WebcamStatus.ACTIVE}
          />
        </NoSsr>
      </div>
      <div className={cx('footer')}>
        <Button onClick={handleClickStart} styles={{ width: 168, height: 48 }}>
          환경체크 시작
        </Button>
      </div>
    </CommonCard>
  );
};
